import script from "./ModalInscripcion.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalInscripcion.vue?vue&type=script&setup=true&lang=ts"

import "./ModalInscripcion.vue?vue&type=style&index=0&id=e43e5c12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e43e5c12"]])

export default __exports__